// extracted by mini-css-extract-plugin
export default {"root":"TimeTable_root__Kf-DB"};